<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tbody *ngFor="let item of childrenInspections; let i = index" class="optimisation-equipment">
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.associate-equipment.equipment-id' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input
                    type="text"
                    class="ir-form-set"
                    [ngModel]="item.data?.machine?.Serial"
                    name="serial{{ i }}"
                    readonly
                  />
                </div>
              </td>
              <td class="th-plugin-line--remove" style="vertical-align: top">
                <i class="material-icons" (click)="remove(item)">remove_circle</i>
              </td>
            </tr>
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.associate-equipment.equipment-name' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input
                    type="text"
                    class="ir-form-set"
                    [ngModel]="item.data?.machine?.name"
                    name="name{{ i }}"
                    readonly
                  />
                </div>
              </td>
              <td></td>
            </tr>
          </tbody>
          <tr class="th-plugin-line--add">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
